import type { MeetingTypeDefinition, MeetingTypesResponse } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchMeetingTypes(context: ApiContext): Promise<MeetingTypesResponse> {
  return apiContextFetch<MeetingTypesResponse>(context, "meeting_types")
}

export function createMeetingType(context: ApiContext, meetingType: Partial<MeetingTypeDefinition>) {
  return apiContextFetch<MeetingTypeDefinition>(context, "meeting_types", {
    method: "POST",
    body: JSON.stringify({ meeting_type: meetingType }),
  })
}

export function updateMeetingType(context: ApiContext, id: string, meetingType: Partial<MeetingTypeDefinition>) {
  return apiContextFetch<MeetingTypeDefinition>(context, `meeting_types/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ meeting_type: meetingType }),
  })
}

export function archiveMeetingType(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `meeting_types/${id}`, {
    method: "DELETE",
  })
}

export function unarchiveMeetingType(context: ApiContext, id: string) {
  return updateMeetingType(context, id, { archived_at: null })
}
